import { Helmet } from "react-helmet";

import PageLayout from "components/layouts/PageLayout";

import CreditReportsTable from "./CreditEvaluationsTable";
import { useCreditEvaluationsFilter } from "./CreditEvaluationsTable/useCreditEvaluationsFilter";

const CreditEvaluationsPage = () => {
  const { filters, searchField } = useCreditEvaluationsFilter();

  return (
    <>
      <Helmet title="Lendzee | All Evaulations" />
      <PageLayout
        title="Credit Evaluations List"
        subtitle="View and evaluate credit reports and scores."
        search={{
          value: searchField.value,
          onChange: searchField.onChange,
          placeholder: "Search by customer or lead source",
        }}
      >
        <CreditReportsTable filters={filters} />
      </PageLayout>
    </>
  );
};

export default CreditEvaluationsPage;
